import { Responsive, Size } from 'const'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

function ProductBox({ svg, info, text }) {
  return (
    <ProductArea>
      <SVG>{svg}</SVG>
      <ProductInfo>{info}</ProductInfo>
      <ProductText>
        <ClampText>{text}</ClampText>
      </ProductText>
    </ProductArea>
  )
}

const ProductArea = styled.div`
  display: grid;
  grid-template-columns: 60px 1fr;
  grid-template-rows: 30px 30px;
`
const SVG = styled.div`
  grid-column: 1 / 2;
  grid-row: 1 / 3;
  display: grid;
  align-items: center;
  @media screen and (max-width: ${Responsive.XS.DOWN}px) {
    svg {
      width: 10vw;
      height: 10vw;
    }
  }
`
const ProductInfo = styled.div`
  font-size: ${Size.FONT.NORMAL};
  grid-column: 2 / 3;
  grid-row: 1;
  display: grid;
  align-items: center;
  font-weight: 500;
`
const ProductText = styled.div`
  font-size: ${Size.FONT.BIG};
  grid-column: 2 / 3;
  grid-row: 2;
  display: grid;
  align-items: center;
  overflow: hidden;
  font-weight: 700;
`

const ClampText = styled.div`
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`

ProductBox.propTypes = {
  svg: PropTypes.object,
  info: PropTypes.string,
  text: PropTypes.string,
}

export default ProductBox
